import React, { useEffect, useState  } from 'react';
import OwlCarousel from 'react-owl-carousel';
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';

const options = {
    margin: 5,
    responsiveClass: true,
    autoplay: true,
    nav: true,
    dots: false,
    loop: true,
    navText: ["<span></span>", "<span></span>"],
    responsive: {
    0: {
    items: 2,
    },
    400: {
    items: 2,
    },
    600: {
    items: 2,
    },
    700: {
    items: 3,
    },
    1000: {
    items: 3,
    
    }
    },
    };

const AlternativeProduct =(props) => {
    
    const [data, setData] = useState(false);

    useEffect(() => {
        if(props.data.alternatives)setData(props);
    }, [props.data]);

    return (
        <>
        {data && 
            <OwlCarousel className="product-flexslider hidden-buttons owl-theme" {...options}>
            {data.data.alternatives && data.data.alternatives.length>0 && data.data.alternatives.map((item, index) => {
                return (
                <div style={{ padding: '10px' }} className="more-views-items" key={index}>
                    <a href={"/product-detail?matnum="+item.matnum} data-image={AuthVerify.getImageLink(item?.imageurl)}
                    data-zoom-image={AuthVerify.getImageLink(item?.imageurl)}>
                    <img id="product-zoom" src={AuthVerify.getImageLink(item?.imageurl)} alt={item.matname} style={{height: "100px", objectFit: "contain"}}/> </a>
                </div>
            )
            })}
            </OwlCarousel>
        }
        </>
        );
}

export default AlternativeProduct